// main tools
import Link from 'next/link'

// components
import { Image } from '@centria-ui-atoms/image'

// bootstrap components
import { Card as BsCard } from 'react-bootstrap'

// styles
import classes from './styles.module.scss'

// types
import type { CardProps as BsCardProps } from 'react-bootstrap'
import type { FC } from 'react'

export interface CardProps extends BsCardProps {
  link?: string
  cardImage?: string
  cardBody?: JSX.Element
  cardFooter?: JSX.Element
  cardOverlay?: JSX.Element
}

export const Card: FC<CardProps> = ({
  link,
  cardBody,
  cardImage,
  cardFooter,
  cardOverlay,
  className = ''
}) => {
  return (
    <BsCard className={`h-100 ${className} ${classes.card}`}>
      {cardImage && (
        <div className={classes.card_image}>
          <Image src={cardImage} layout='fill' />
        </div>
      )}
      {cardOverlay &&
        (link ? (
          <Link href={link} role='button'>
            <BsCard.ImgOverlay className={classes.card_overlay}>
              {cardOverlay}
            </BsCard.ImgOverlay>
          </Link>
        ) : (
          <BsCard.ImgOverlay className={classes.card_overlay}>
            {cardOverlay}
          </BsCard.ImgOverlay>
        ))}
      {cardBody && (
        <BsCard.Body className={classes.card_body}>{cardBody}</BsCard.Body>
      )}
      {cardFooter && (
        <BsCard.Footer className={classes.card_footer}>
          {cardFooter}
        </BsCard.Footer>
      )}
    </BsCard>
  )
}
